import ChallengeInstance from './components/ChallengeInstance.vue';
import AdminInstances from './components/admin/AdminInstances.vue';
import AdminInstancerForm from './components/admin/AdminInstancerForm.vue';

export default {
  install(vue) {
    // Extend challenge page
    vue.$ctforge.registerComponent(ChallengeInstance, { type: 'challenge', position: 'right' });
    vue.$ctforge.registerComponent(AdminInstancerForm, { type: 'admin_challenge_form', priority: 2 });
    vue.$router.addChildrenRoutes('/admin', [
      {
        path: 'instances',
        component: AdminInstances,
        meta: { requiresAdmin: true },
      },
    ]);
    vue.$ctforge.addAdminLinks([
      { name: 'Instances', path: '/admin/instances', icon: 'server' },
    ]);
  },
};
